import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { useSelector } from "react-redux";
import { useCollapsibleSectionsContext } from "~/components/AssetModalV2/InfoPanel/CollapsibleSectionsContextProvider";
import { CollapsibleSection } from "~/components/AssetModalV2/InfoPanel/components/CollapsibleSection";
import { FileInfo } from "~/components/AssetModalV2/InfoPanel/DescriptionAndTags/FileInfo";
import { SmartTagKeywords } from "~/components/AssetModalV2/InfoPanel/DescriptionAndTags/SmartTagKeywords";
import { centralizedClipSummarySelector } from "~/store/centralizedClip/selectors";
export const PublicDescriptionAndTagsCollapsibleSection = /*#__PURE__*/ memo(()=>{
    const summary = useSelector(centralizedClipSummarySelector);
    const { expandedSections, toggleSection } = useCollapsibleSectionsContext();
    const isExpanded = expandedSections["descriptionAndTags"];
    const onOpenChange = useCallback(()=>{
        toggleSection("descriptionAndTags");
    }, [
        toggleSection
    ]);
    return /*#__PURE__*/ _jsx(CollapsibleSection, {
        title: "Description and Tags",
        isExpanded: isExpanded,
        onOpenChange: onOpenChange,
        "data-testid": "DESCRIPTION_AND_TAGS_SECTION",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col gap-4",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "text-12 text-grey-11",
                    "data-testid": "INFO_PANEL_SUMMARY_TEXT",
                    children: summary
                }),
                /*#__PURE__*/ _jsx(SmartTagKeywords, {}),
                /*#__PURE__*/ _jsx(FileInfo, {})
            ]
        })
    });
});
PublicDescriptionAndTagsCollapsibleSection.displayName = "PublicDescriptionAndTagsCollapsibleSection";
